import { useState } from 'react';
import { Link } from '@tanstack/react-router';
import { MdAdd, MdLock } from 'react-icons/md';
import { Button } from '@/components/Button';
import Loading from '@/components/Loading';
import useProvidedJobPostLists from '../api/useProvidedJobPostLists';
import useFetchIam from '@/features/agent/api/useFetchIam';
import CreateListDialog from '../components/CreateListDialog';
import ListActionMenu from '../components/ListActionMenu';

export default function ProvidedJobPostListsIndexTemplate() {
  const { data: lists, isLoading } = useProvidedJobPostLists();
  const { data: iam } = useFetchIam();
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const currentUserId = iam?.current_user?.id;

  return (
    <div className="flex flex-col gap-6 p-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">リスト管理</h1>
        <Button color="primary" size="md" onClick={() => setIsCreateOpen(true)}>
          <MdAdd className="size-icon-xs" />
          新しいリストを作成
        </Button>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-16">
          <Loading size="medium" />
        </div>
      ) : !lists || lists.length === 0 ? (
        <div className="flex flex-col items-center gap-4 py-16 text-gray-500">
          <p className="text-lg">リストがありません</p>
          <p className="text-sm">「新しいリストを作成」ボタンからリストを作成してください。</p>
        </div>
      ) : (
        <div className="overflow-hidden rounded border border-solid border-border bg-white">
          <table className="w-full table-fixed">
            <thead>
              <tr className="border-b border-solid border-border bg-gray-50">
                <th className="px-6 py-3 text-left text-xs font-bold text-gray-600">リスト名</th>
                <th className="w-[160px] px-6 py-3 text-left text-xs font-bold text-gray-600">
                  求人数
                </th>
                <th className="w-[160px] px-6 py-3 text-left text-xs font-bold text-gray-600">
                  作成者
                </th>
                <th className="w-[60px] px-6 py-3" />
              </tr>
            </thead>
            <tbody>
              {lists.map((list) => (
                <tr
                  key={list.id}
                  className="border-b border-solid border-border last:border-b-0 focus-within:bg-white hover:bg-gray-50"
                >
                  <td className="px-6 py-4">
                    <Link
                      to={'/agent/provided_job_post_lists/$listId' as never}
                      params={{ listId: list.uuid } as never}
                      className="flex items-center gap-2 text-sm font-bold text-inherit no-underline"
                    >
                      {list.name}
                      {!list.is_public && <MdLock className="size-4 shrink-0" />}
                    </Link>
                  </td>
                  <td className="px-6 py-4 text-sm">{list.provided_job_posts_count}件</td>
                  <td className="px-6 py-4">
                    <span className="flex h-lg w-fit items-center justify-center rounded-full border border-solid border-border px-3 text-xs">
                      {list.created_by_name}
                    </span>
                  </td>
                  <td className="px-2 py-4">
                    <ListActionMenu
                      listId={list.uuid}
                      listName={list.name}
                      isPublic={list.is_public}
                      isOwner={currentUserId === list.created_by_id}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <CreateListDialog
        open={isCreateOpen}
        onOpenChange={setIsCreateOpen}
        onCreated={() => setIsCreateOpen(false)}
      />
    </div>
  );
}
